<template>
  <div class="well ordertrack">
    <!--------------------------------- 收货人信息 ----------------------------------------->
    <div class="orderinfo">
      <h2 class="mt">收货人信息</h2>
      <ul class="mc">
        <li>
          <div class="span7"><span class="span3 text-right" style="width: 75px;">订单号：</span> {{json[0].value}}</div>
        </li>
        <li>
          <div class="span7"><span class="span3 text-right" style="width: 75px;">收货人：</span> {{json[2].value[0].value}}
          </div>
          <div class="span7"><span class="span3 text-right" style="width: 75px;">手机号：</span> {{json[2].value[1].value}}
          </div>
        </li>
        <li>
          <div class="span7"><span class="span3 text-right" style="width: 75px;">邮政编码：</span> {{json[2].value[2].value}}
          </div>
          <div class="span7"><span class="span3 text-right" style="width: 75px;">固定电话：</span> {{json[2].value[3].value}}</div>
        </li>
        <li><span class="span1 text-right" style="width: 75px;">收货地址：</span> {{json[2].value[4].value}}</li>
      </ul>
    </div>
    <!--------------------------------- 包裹信息 ----------------------------------------->
    <div class="orderinfo">
      <h2 class="mt">包裹信息</h2>
      <ul class="mc">
        <li>渠道：{{json[3].value[0].value}}</li>
        <input type="hidden" id="chl_attr" ins_ratio="0.03" mergepacks_fee="3/10" unpacks_fee="3/10">
        <!--<li class="gray999"><i class="exclamation"></i>-->
        <!--购物网站=&gt;香港仓库=&gt;大陆客户地址，有关税补贴，适用于单价&lt;140美元的普通物品。-->
        <!--</li>-->
        <!--<li>备注：3</li>-->
      </ul>
      <div class="mc">
        <table class="table table-bordered" cellspacing="0" cellpadding="0">
          <thead>
          <tr style=" background: #f1f1f1;">
            <th>包裹邮单号</th>
            <th>商品名称</th>
            <th>规格</th>
            <th>品牌</th>
            <th>申报类别</th>
            <th>单价(美元(USD))</th>
            <th>数量</th>
          </tr>
          </thead>
          <tbody>
          <input type="hidden" id="pk_num" value="1">
          <tr v-for="(item,i) in json[3].value[1].value" :key="i" v-if="i!=0">
            <td rowspan="1">{{item[0]}}</td>
            <td><a href="javascript:;" title="lululemon天蓝色紧身短裤LW7CJQS">{{item[1]}}</a></td>
            <td>{{item[2]}}</td>
            <td>{{item[3]}}</td>
            <td>{{item[4]}}</td>
            <td class="red">{{item[5]}}</td>
            <td>{{item[6]}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div style="overflow: hidden;">
      <div class="span8" style="border-right: 1px solid #ececec;">
        <div class="orderinfo">
          <h2 class="mt">增值服务</h2>
          <ul class="mc">
            <li class="labelleft"></li>
            <li class="m20"><span style="color:red">合计：￥<span id="srv_value_sum">{{json[6].value}}</span></span></li>
          </ul>
        </div>
        <div class="orderinfo">
          <div>
            <h2 class="mt">运费信息</h2>
            <ul class="mc">
              <li class="m20">
                <span v-for="(item,i) in json[5].value" :key="i" :class="item.key=='合计'?'red':''">{{item.key}}:{{item.value}}</span>
                <!--<span>总重量：0.40千克(KG)</span>-->
                <!--<span>体积费：￥0.00</span>-->
                <!--<span>基础运费：￥85</span>-->
                <!--<span>用户折扣：0.85折</span>-->
                <!--<span>折扣费：￥12.75</span>-->
                <!--<span></span>-->
                <!--<span style="color:red">合计：￥72.25</span>-->
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="total span4">
        <ul>
          <li>
            <span style="display: inline-block; text-align: right; width: 85px;">增值服务：</span>
            {{json[6].value}}
          </li>
          <li style="width:227px">
            <span style="display: inline-block; text-align: right; width: 85px;">+ 运费合计：</span>
            {{json[7].value}}
          </li>
          <li>
            <span style="display: inline-block; text-align: right; width: 85px;">- 积分支付：</span>
            {{json[8].value}}
          </li>
        </ul>
        <div class="extra" style="width:227px">
          应付总额：
          <span class="red f20">{{json[9].value}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  let _ = require('lodash')
  export default {
    name: 'bd',
    props: ['json'],
    components: {},
    data() {
      return {}
    },
    created() {

    },
    methods: {}
  }
</script>
<style scoped>
  @import './bootstrap-responsive.css';
  @import './bootstrap.css';
</style>

<style scoped lang="scss">
  .table {
    margin: 0;
  }

  .ordertrack {
    background-color: #fff;
    border: none;
    padding: 0;
  }

  .ordertrack .orderinfo {
    color: #333;
    overflow: hidden;
  }

  .orderinfo .mt {
    border-top: 1px solid #ececec;
    padding: 15px 0 0 15px;
    font-size: 15px;
    line-height: 20px;
    margin: 0;
  }

  .orderinfo .mc {
    padding: 10px 31px;
    overflow: hidden;
    margin: 0;
    font-size: 12px;
  }

  .orderinfo .mc li {
    line-height: 20px;
    overflow: hidden;
    margin: 0;
  }

  .gray999 {
    color: #999;
  }

  .orderinfo .mc li .exclamation {
    display: inline-block;
    background: url(exclamation.png) no-repeat center center;
    width: 16px;
    height: 16px;
    margin-right: 5px;
    vertical-align: middle;
  }

  .ordertrack .total {
    border-top: 1px solid #ececec;
    margin: 0;
    width: 31.188%;
  }

  .ordertrack .total ul {
    /*float: right;*/
    font-size: 14px;
    /*margin: 50px 50px 0 0;*/
    margin-top: 2rem;
    line-height: 30px;
  }

  .ordertrack .total .extra {
    border-top: 1px solid #ccc;
    /*float: right;*/
    font-size: 14px;
    line-height: 40px;
    font-weight: bold;
    /*margin: 10px 37px 0 0;*/
    margin: 0 0 10px 25px;
  }

  .red {
    color: #c21e26;
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/express_bill/bd/index.vue